/**
 * Datos de servicios de la empresa
 * Centralizado para fácil mantenimiento
 */

// Servicios principales mostrados en la página de inicio
export const MAIN_SERVICES = [
  {
    id: 'atencion-personalizada',
    icon: 'FaUserNurse',
    title: "Plan de Cuidado VIP Personalizado",
    description: "Atención individualizada diseñada a la medida de cada paciente, con personal certificado y un protocolo de cuidado elaborado junto al médico tratante"
  },
  {
    id: 'servicio-24-7',
    icon: 'FaClock',
    title: "Disponibilidad Exclusiva 24/7",
    description: "Presencia profesional continua los 365 días del año, con respuesta inmediata ante cualquier eventualidad y supervisión médica permanente"
  },
  {
    id: 'cobertura-anual',
    icon: 'FaCalendarAlt',
    title: "Acompañamiento Integral Continuo",
    description: "Seguimiento clínico ininterrumpido con reportes periódicos a la familia, garantizando coherencia y excelencia en cada etapa del cuidado"
  }
];

// Servicios detallados para la página de servicios
export const DETAILED_SERVICES = [
  {
    id: 'cuidadoras',
    title: 'Cuidadoras Especializadas a Domicilio en Guadalajara',
    image: 'cuidadoras',
    alt: 'Cuidadora certificada brindando atención VIP personalizada a adulto mayor en Guadalajara',
    description: 'Nuestras cuidadoras, seleccionadas mediante riguroso proceso de verificación y certificación, ofrecen asistencia integral personalizada, compañía especializada y monitoreo constante de salud para adultos mayores y pacientes en recuperación postoperatoria en Guadalajara y zona metropolitana.',
    features: [
      'Asistencia en actividades diarias con enfoque en autonomía y dignidad',
      'Compañía, acompañamiento emocional y estimulación cognitiva',
      'Monitoreo continuo de signos vitales con registro clínico',
      'Administración supervisada de medicamentos orales',
      'Preparación de alimentos según prescripción médica y preferencias',
      'Acompañamiento a consultas médicas y estudios de laboratorio',
      'Reportes diarios detallados a la familia',
      'Activación física, recreación y estimulación funcional'
    ],
    priceInfo: 'Plan de atención personalizado. Contáctenos para una evaluación inicial.',
    icon: 'FaHandHoldingMedical'
  },
  {
    id: 'auxiliares',
    title: 'Auxiliares de Enfermería Certificados en Guadalajara',
    image: 'auxiliar',
    alt: 'Auxiliar de enfermería certificado atendiendo paciente con estándares hospitalarios en Guadalajara',
    description: 'Personal certificado en técnicas avanzadas de enfermería, seleccionado con riguroso control de confianza, para brindar cuidados clínicos integrales a pacientes que requieren atención especializada en la comodidad y privacidad de su hogar.',
    features: [
      'Cuidado de heridas y curaciones con protocolos hospitalarios',
      'Control, registro y análisis de signos vitales',
      'Apoyo en higiene y cuidado personal con máximo respeto a la dignidad',
      'Administración de medicamentos por vía oral bajo supervisión',
      'Movilización terapéutica y cambios de posición programados',
      'Prevención y cuidado especializado de úlceras por presión',
      'Alimentación asistida y manejo de sondas',
      'Rehabilitación funcional básica supervisada'
    ],
    priceInfo: 'Plan de cuidado a la medida. Solicite su evaluación inicial sin compromiso.',
    icon: 'FaSyringe'
  },
  {
    id: 'enfermeria-general',
    title: 'Enfermería General de Élite a Domicilio',
    image: 'general',
    alt: 'Enfermera con cédula profesional brindando atención médica de élite en domicilio',
    description: 'Enfermeras tituladas con cédula profesional vigente para procedimientos médicos especializados y cuidados postoperatorios de alta complejidad, con estándares equivalentes a los de las mejores instituciones hospitalarias privadas.',
    features: [
      'Aplicación de medicamentos inyectables con protocolos de asepsia',
      'Canalización y manejo avanzado de catéteres y accesos venosos',
      'Curaciones avanzadas y manejo especializado de heridas',
      'Toma y procesamiento de muestras de laboratorio a domicilio',
      'Cuidados postoperatorios especializados y seguimiento clínico',
      'Monitoreo y operación de equipos médicos domiciliarios',
      'Coordinación directa y continua con médicos tratantes',
      'Elaboración de reportes clínicos detallados para el equipo médico'
    ],
    priceInfo: 'Servicio de élite con plan personalizado. Contáctenos para una valoración inicial.',
    icon: 'FaHeartbeat'
  },
  {
    id: 'sueros-aplicaciones',
    title: 'Aplicación de Sueros e Inyecciones a Domicilio',
    image: 'suero',
    alt: 'Enfermera certificada aplicando suero intravenoso con estándares hospitalarios premium a domicilio',
    description: 'Servicio exclusivo de aplicación de sueros, medicamentos intravenosos e inyecciones en la comodidad y privacidad del hogar, ejecutado por enfermeras tituladas con todos los protocolos de seguridad y asepsia hospitalaria.',
    features: [
      'Aplicación de sueros y soluciones intravenosas con protocolo hospitalario',
      'Inyecciones intramusculares con técnica certificada',
      'Inyecciones subcutáneas e intradérmicas precisas',
      'Administración de medicamentos IV bajo supervisión continua',
      'Hidratación parenteral y soporte nutricional',
      'Atención urgente a domicilio con disponibilidad prioritaria',
      'Material y equipo médico estéril incluido',
      'Supervisión clínica completa durante todo el procedimiento'
    ],
    priceInfo: 'Servicio de atención prioritaria. Contáctenos para disponibilidad inmediata.',
    icon: 'FaMedkit'
  }
];

export const INFO_SECTIONS_SERVICES = [
  {
    title: "Cuidadoras Especializadas",
    description: "Personal certificado con riguroso control de confianza, especializado en atención personalizada VIP: asistencia en aseo, nutrición supervisada y administración de medicamentos.",
    image: "cuidadoras",
    alt: "Cuidadora certificada brindando atención VIP a un adulto mayor",
    sectionId: "cuidadoras"
  },
  {
    title: "Auxiliares de Enfermería",
    description: "Expertos en cuidado clínico de pacientes crónicos: monitoreo de signos vitales, curaciones con protocolos hospitalarios, apoyo emocional y planes de atención individualizados.",
    image: "auxiliar",
    alt: "Auxiliar de enfermería certificado tomando signos vitales",
    sectionId: "auxiliares"
  },
  {
    title: "Enfermera con Cédula Profesional",
    description: "Cuidados postoperatorios de élite, coordinación directa con el equipo médico tratante y ejecución de procedimientos especializados con estándares hospitalarios en su hogar.",
    image: "enfermeria",
    alt: "Enfermera titulada revisando historial médico del paciente",
    sectionId: "enfermeria-general"
  },
  {
    title: "Sueros e Inyecciones a Domicilio",
    description: "Aplicación de sueros, inyecciones y medicamentos intravenosos en la privacidad de su hogar, ejecutada por enfermeras tituladas con todos los protocolos de asepsia hospitalaria.",
    image: "sueros",
    alt: "Enfermera certificada aplicando suero con protocolos hospitalarios a paciente en casa",
    sectionId: "sueros-aplicaciones"
  }
];
